var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4749 10.2045C15.8662 9.49366 15.5896 8.87763 15.5896 7.83104V7.47519C15.5896 6.11136 15.2757 5.23264 14.5932 4.35391C13.5414 2.98924 11.7706 2.16675 10.0372 2.16675H9.96347C8.26645 2.16675 6.55121 2.95147 5.48115 4.26075C4.76143 5.1571 4.4111 6.07359 4.4111 7.47519V7.83104C4.4111 8.87763 4.15269 9.49366 3.52573 10.2045C3.06441 10.7282 2.91699 11.4013 2.91699 12.1298C2.91699 12.8592 3.15635 13.5499 3.63671 14.1114C4.26367 14.7845 5.14904 15.2142 6.05345 15.2889C7.36287 15.4383 8.67228 15.4945 10.0007 15.4945C11.3284 15.4945 12.6378 15.4005 13.948 15.2889C14.8516 15.2142 15.737 14.7845 16.3639 14.1114C16.8435 13.5499 17.0837 12.8592 17.0837 12.1298C17.0837 11.4013 16.9362 10.7282 16.4749 10.2045Z",
    fill: "#5570F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.6745 16.5238C11.2579 16.4348 8.71937 16.4348 8.30278 16.5238C7.94664 16.606 7.56152 16.7974 7.56152 17.217C7.58223 17.6173 7.81661 17.9707 8.14128 18.1948L8.14045 18.1956C8.56035 18.5229 9.05314 18.7311 9.56912 18.8058C9.84409 18.8435 10.124 18.8418 10.4089 18.8058C10.9241 18.7311 11.4169 18.5229 11.8368 18.1956L11.836 18.1948C12.1606 17.9707 12.395 17.6173 12.4157 17.217C12.4157 16.7974 12.0306 16.606 11.6745 16.5238Z",
    fill: "#5570F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.01beac980b792a4bbe82b986a604e377.svg";
export { ForwardRef as ReactComponent };